export const formatINR = (n) => {
  if (n === undefined || n === null) return '—';
  const num = typeof n === 'string' ? parseFloat(n) : n;
  if (Number.isNaN(num)) return '—';
  return new Intl.NumberFormat('en-IN').format(num);
};

export const formatArea = (n) => {
  if (!n && n !== 0) return '—';
  return `${new Intl.NumberFormat('en-IN').format(n)} sq ft`;
};

export const formatBudgetRange = (min, max) => {
  if (!min && !max) return 'On request';
  if (min && max && min !== max) return `₹${formatINR(min)} – ₹${formatINR(max)} / sq ft / month`;
  const v = min || max;
  return `₹${formatINR(v)} / sq ft / month`;
};

export const propertyTypeLabel = (t) => ({
  office: 'Office',
  retail: 'Retail',
  coworking: 'Coworking',
  'mixed-use': 'Mixed-Use',
  warehouse: 'Warehouse',
}[t] || t);

export const statusLabel = (s) => ({
  available: 'Available',
  leased: 'Leased',
  upcoming: 'Upcoming',
}[s] || s);

export const formatDate = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
};
